<template>
    <div class="container">
        <div class="section">
            <img src="https://s20.lgstatic.com/growth/activity/20220602/1654158613400.png" alt="">
            <img v-if="!trainingCampCoupon.alreadyReceive" @click="showTrainingCampCoupon" class="coupon-img" src="https://s20.lgstatic.com/growth/activity/20220606/1654497814164.png">
            <img v-else class="coupon-img" src="https://s21.lgstatic.com/growth/activity/20220606/1654497837633.png">
        </div>
        <div class="section">
            <img src="https://s21.lgstatic.com/growth/activity/20220602/1654158659727.png" alt="">
            <img class="re-icon" src="https://s21.lgstatic.com/growth/activity/20220602/1654159211058.png" alt="">
            <img class="re-btn"  @click="goOfferForm" src="https://s21.lgstatic.com/growth/activity/20220602/1654159012408.png" alt="">
        </div>
        <div style="height: 25px"></div>
        <div class="section">
            <img src="https://s21.lgstatic.com/growth/activity/20220602/1654158747478.png" alt="">
            <img class="re-icon2" src="https://s21.lgstatic.com/growth/activity/20220602/1654162661922.png" alt="">
            <div class="study-container">
                <img class="study-img study-img-1" src="https://s20.lgstatic.com/growth/activity/20220602/1654159376716.png"  @click="handleTrainClick('d68a28c6a455442fbace617b3d27dc54')">
                <img class="study-img study-img-2" src="https://s20.lgstatic.com/growth/activity/20220602/1654159376716.png"  @click="handleTrainClick('595408de2a5b418d82cf75f7b19afaa4')">
                <img class="study-img study-img-3" src="https://s20.lgstatic.com/growth/activity/20220602/1654159376716.png"  @click="handleTrainClick('b9bbe7ae829f4480bc0d860ebf2b1970')">
                <img class="study-img study-img-4" src="https://s20.lgstatic.com/growth/activity/20220602/1654159376716.png"  @click="handleTrainClick('f331871ccf91414896e61eacd84d1429')">
                <img class="study-img study-img-5" src="https://s20.lgstatic.com/growth/activity/20220602/1654159376716.png"  @click="handleTrainClick('ec5e7096784f4c12acb30509179da508')">
                <img class="study-img study-img-6" src="https://s20.lgstatic.com/growth/activity/20220602/1654159376716.png"  @click="handleTrainClick('ed1890dd539543ef9f01d38018e5d3d0')">
                <img class="study-img study-img-7" src="https://s20.lgstatic.com/growth/activity/20220602/1654159376716.png"  @click="handleTrainClick('0279ee5641134bdd9c792ccdf89d319f')">
                <img class="study-img study-img-8" src="https://s20.lgstatic.com/growth/activity/20220602/1654159376716.png"  @click="handleTrainClick('b81a5c0d7dc94c3f88de261065ea56b3')">
            </div>
        </div>
        <div class="section">
            <img src="https://s20.lgstatic.com/growth/activity/20220602/1654158776354.png" alt="">
        </div>
        <div class="footer" @click="goOffer">
            <img src="https://s21.lgstatic.com/growth/activity/20220602/1654158823453.png" alt="">
        </div>
        <div v-if="visibleModal" class="recevice-coupon">
            <div class="recevice-coupon-content">
                <div class="recevice-coupon-wrap">
                    <img class="recevice-coupon-img" src="https://s20.lgstatic.com/growth/activity/20220606/1654498422668.png">
                    <div class="subject-list">
                        <div
                            :class="{
                                'subject-item': true,
                                'actived': selectSubject == subject.type
                            }"
                            v-for="subject in subjectList"
                            :key="subject.type"
                            @click="selectedFn(subject.type)"
                        >{{subject.subjectName}}</div>
                    </div>
                </div>
                <div v-if="!selectSubject" class="recevice-coupon-btn">请选择学科</div>
                <div v-else class="recevice-coupon-btn" @click="selected">选好了，抢占优惠</div>
                <div class="close-btn" @click="visibleModal = false"></div>
            </div>
        </div>
        <div v-if="receviceSuccessModal" class="recevice-success">
            <div class="recevice-content">
                <div class="recevice-wrap">
                    <img class="recevice-img" src="https://s20.lgstatic.com/growth/activity/20220328/1648454452724.png">
                    <div class="recevice-txt">优惠券已发送您 {{userLoginAccount}} 账户</div>
                </div>
                <div class="learn-btn" @click="goDetail">查看学科资料</div>
                <div class="later-btn" @click="receviceSuccessModal = false">稍后查看</div>
            </div>
        </div>
    </div>
</template>

<script>
import * as Cookies from 'js-cookie';
import { handleJumpUrl } from '../../../uitl/getParam.js';
import { getBigCourseCoupon, receiveBigCourseCoupon, fetchUserInfo } from '../../../service/api'
import { Toast } from 'vant';
export default {
    data() {
        return {
            subjectList: [
                { type: 1, subjectName: "Java", imgUrl: 'https://s21.lgstatic.com/growth/activity/20220331/1648709857214.png',url: 'https://edu.lagou.com/growth/sem/java_architect.html', formId: 'd68a28c6a455442fbace617b3d27dc54' },
                { type: 2, subjectName: "前端", imgUrl: 'https://s21.lgstatic.com/growth/activity/20220331/1648709872346.png',url: 'https://edu.lagou.com/growth/sem/fe-next.html', formId: '595408de2a5b418d82cf75f7b19afaa4' },
                { type: 3, subjectName: "大数据", imgUrl: 'https://s21.lgstatic.com/growth/activity/20220331/1648709884836.png',url: 'https://edu.lagou.com/growth/sem/data_enhancement.html', formId: 'b9bbe7ae829f4480bc0d860ebf2b1970' },
                { type: 4, subjectName: "数据分析", imgUrl: 'https://s21.lgstatic.com/growth/activity/20220331/1648709822126.png',url: 'https://edu.lagou.com/growth/sem/data_analysis.html', formId: 'ec5e7096784f4c12acb30509179da508' },
                { type: 5, subjectName: "测试", imgUrl: 'https://s21.lgstatic.com/growth/activity/20220331/1648709900045.png',url: 'https://edu.lagou.com/growth/sem/test_engineer.html', formId: '0279ee5641134bdd9c792ccdf89d319f' },
                { type: 6, subjectName: "产品", imgUrl: 'https://s21.lgstatic.com/growth/activity/20220331/1648709914157.png',url: 'https://edu.lagou.com/growth/sem/pm__enhancement.html', formId: 'f331871ccf91414896e61eacd84d1429' },
                { type: 7, subjectName: "运营", imgUrl: 'https://s20.lgstatic.com/growth/activity/20220331/1648709925863.png',url: 'https://edu.lagou.com/growth/sem/all_operate.html', formId: 'b81a5c0d7dc94c3f88de261065ea56b3' },
                { type: 8, subjectName: "商业分析", imgUrl: 'https://s20.lgstatic.com/growth/activity/20220331/1648709925863.png',url: 'https://edu.lagou.com/growth/sem/all_operate.html', formId: 'ed1890dd539543ef9f01d38018e5d3d0' }
            ],
            selectSubject: '',
            visibleModal: false,
            trainingCampCoupon: {},
            userInfo: {},
            userLoginAccount: '',
            receviceSuccessModal: false
        }
    },
    created () {
        if (Cookies.get('gate_login_token') || Cookies.get('edu_gate_login_token')) {
          this.initCouponStatus();
        }
    },
    methods: {
        initCouponStatus() {
            getBigCourseCoupon().then(res => {
                if (res.state == 1) {
                    this.trainingCampCoupon = res.content.trainingCampCoupon || {};
                }
            })
            fetchUserInfo().then(res => {
                if (res.state == 1) {
                    this.userInfo = res.content || {};
                }
            })
        },
        selected() {
            const data = {
                couponNo: this.trainingCampCoupon.couponNo,
                subjectId: this.selectSubject
            }
            this.receiveBigCourseCouponFn(data);
        },
        selectedFn(type) {
            this.selectSubject = type;
        },
        handleTrainClick(formId) {
            handleJumpUrl(formId);
        },
        isLogin() {
            return Cookies.get('gate_login_token') || Cookies.get('edu_gate_login_token');
        },
        goOffer() {
            window.location.href = 'https://edu.lagou.com/growth/sem/offer.html';
        },
        goOfferForm() {
            handleJumpUrl('96e584784cb94c178ea397db3e409117');
        },
        showTrainingCampCoupon() {
            if (!Cookies.get('gate_login_token') && !Cookies.get('edu_gate_login_token')) {
                return window.open('/frontLogin.do', '_self');
            }
            this.selectSubject = '';
            this.visibleModal = true;
        },
        receiveBigCourseCouponFn(data) {
            receiveBigCourseCoupon(data).then(res => {
                if (res.state == 1) {
                    this.userLoginAccount =  res.content.userLoginAccount || '';
                    this.receviceSuccessModal = true;
                    this.initCouponStatus();
                } else {
                    Toast(res.message);
                }
            }).finally(() => {
                this.visibleModal = false;
            })
        },
        goDetail() {
            window.location.href = this.subjectList[this.selectSubject - 1].url;
        },
    },
}
</script>

<style lang="less" scoped>
.container {
    position: relative;
    width: 100%;
    overflow-y: auto;
    padding-bottom: 237px;
    background-color: #FF3439;
}
.section {
    position: relative;
    display: flex;
    width: 100%;
    img {
        width: 100%;
    }
    .coupon-img {
        position: absolute;
        top: 435px;
        left: 0;
    }
    .re-btn {
        position: absolute;
        top: 777px;
        left: 141px;
        width: 465px;
        height: 96px;
    }
    .re-icon {
        position: absolute;
        right: 0;
        top: -6px;
        width: 177px;
        height: 97px;
    }
    .re-icon2 {
        position: absolute;
        right: 0;
        top: -20px;
        width: 177px;
        height: 97px;
    }
}
.footer {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 184px;
    img {
        width: 100%;
    }
}
.study-container {
    position: absolute;
    left: 30px;
    top: 0;
    width: 690px;
    height: 887px;
    .study-img {
        position: absolute;
        width: 270px;
        height: 70px;
        &-1 {
            top: 400px;
            left: 40px;
        }
        &-2 {
            top: 400px;
            right: 40px;
        }
        &-3 {
            top: 755px;
            left: 40px;
        }
        &-4 {
            top: 755px;
            right: 40px;
        }
        &-5 {
            top: 1110px;
            left: 40px;
        }
        &-6 {
            top: 1110px;
            right: 40px;
        }
        &-7 {
            top: 1464px;
            left: 40px;
        }
        &-8 {
            top: 1464px;
            right: 40px;
        }
    }
}
.recevice-coupon {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 1, 31, .45);
    .recevice-coupon-content {
        position: absolute;
        top: 45%;
        left: 50%;
        width: 600px;
        height: 550px;
        transform: translateX(-50%) translateY(-50%);
    }
    .recevice-coupon-wrap {
        width: 600px;
        height: 555px;
        background-color: #FF3056;
        border-radius: 12px;
        overflow: hidden;
        .recevice-coupon-img {
            display: block;
            width: 324px;
            height: 87px;
            margin: 92px auto 0;
        }
        .subject-list {
            display: flex;
            width: 560px;
            height: 212px;
            padding-top: 42px;
            margin: 47px auto 0;
            box-sizing: border-box;
            background-color: #DE111C;
            border-radius: 4px;
            justify-content: center;
            flex-wrap: wrap;
            .subject-item {
                min-width: 113px;
                height: 54px;
                line-height: 54px;
                padding: 0 14px;
                box-sizing: border-box;
                font-size: 26px;
                color: #fff;
                text-align: center;
                margin-bottom: 27px;
                margin-right: 20px;
                background-color: #FF7E7E;
                border-radius: 3px;
                &:nth-child(4n) {
                    margin-right: 0;
                }
                &.actived {
                    background-color: #AA0000;
                }
            }
        }
    }
    .recevice-coupon-btn {
        position: absolute;
        bottom: -40px;
        left: 50%;
        width: 389px;
        height: 80px;
        line-height: 80px;
        text-align: center;
        border-radius: 40px;
        background: linear-gradient(180deg, #FFFFFF 0%, #FFC0C9 100%);
        font-size: 36px;
        font-weight: bold;
        color: #FF3056;
        transform: translateX(-50%);
    }
    .close-btn {
        position: absolute;
        bottom: -140px;
        left: 50%;
        width: 70px;
        height: 70px;
        background: url("https://s21.lgstatic.com/growth/activity/20220328/1648455391724.png") no-repeat center;
        background-size: 70px 70px;
        transform: translateX(-50%);
    }
}
.recevice-success {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 1, 31, .45);
    z-index: 999;
    .recevice-content {
        position: absolute;
        top: 45%;
        left: 50%;
        width: 600px;
        height: 550px;
        transform: translateX(-50%) translateY(-50%);
        &-2 {
            height: 286px;
        }
    }
    .recevice-wrap {
        width: 600px;
        height: 286px;
        background-color: #FF506D;
        border-radius: 12px;
        overflow: hidden;
        padding: 0 30px;
        box-sizing: border-box;
        .recevice-img {
            display: block;
            width: 202px;
            height: 40px;
            margin: 92px auto 0;
            &-1 {
                display: block;
                width: 250px;
                height: 40px;
                margin: 75px auto 0;
            }
        }
        .recevice-txt {
            text-align: center;
            font-size: 26px;
            color: #fff;
            margin-top: 31px;
        }
    }
    .recevice-coupon-btn {
        width: 389px;
        height: 80px;
        line-height: 80px;
        text-align: center;
        border-radius: 40px;
        background: linear-gradient(166deg,  #da0528, #FF506D);
        font-size: 36px;
        font-weight: bold;
        color: #fff;
        margin: 30px auto 0;
    }
    .learn-btn {
        width: 389px;
        height: 80px;
        background: linear-gradient(166deg, #da0528, #FF506D);
        border-radius: 40px;
        margin: 39px auto 0;
        line-height: 80px;
        text-align: center;
        font-size: 36px;
        color: #fff;
        font-weight: bold;
    }
    .later-btn {
        margin-top: 32px;
        text-align: center;
        font-size: 30px;
        font-style: italic;
        color: #fff;
    }
    .close-btn {
        position: absolute;
        bottom: -70px;
        left: 50%;
        width: 70px;
        height: 70px;
        background: url("https://s21.lgstatic.com/growth/activity/20220328/1648455391724.png") no-repeat center;
        background-size: 70px 70px;
        transform: translateX(-50%);
    }
    .close-btn-2 {
        position: absolute;
        bottom: -110px;
        left: 50%;
        width: 70px;
        height: 70px;
        background: url("https://s21.lgstatic.com/growth/activity/20220328/1648455391724.png") no-repeat center;
        background-size: 70px 70px;
        transform: translateX(-50%);
    }
    .close-btn-3 {
        position: absolute;
        top: -106px;
        right: 0;
        width: 70px;
        height: 70px;
        background: url("https://s21.lgstatic.com/growth/activity/20220328/1648455391724.png") no-repeat center;
        background-size: 70px 70px;
    }
}
</style>
